/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProfileInput
 */
export interface UserProfileInput {
    /**
     * 
     * @type {string}
     * @memberof UserProfileInput
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileInput
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileInput
     */
    phone?: string;
}

/**
 * Check if a given object implements the UserProfileInput interface.
 */
export function instanceOfUserProfileInput(value: object): value is UserProfileInput {
    return true;
}

export function UserProfileInputFromJSON(json: any): UserProfileInput {
    return UserProfileInputFromJSONTyped(json, false);
}

export function UserProfileInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileInput {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function UserProfileInputToJSON(json: any): UserProfileInput {
    return UserProfileInputToJSONTyped(json, false);
}

export function UserProfileInputToJSONTyped(value?: UserProfileInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
    };
}

